import React, { useState ,useEffect} from "react";
import axios from "../utils/axios";
import { FiMail, FiLock } from "react-icons/fi"; // Icons for the email and password fields
import { FaGoogle, FaApple } from "react-icons/fa"; // Social login icons
import login_logo from '../assets/img/login.svg'; // Replace with your illustration URL
import official_logo from '../assets/logo/white.png'; // Replace with your logo URL
import { useNavigate } from 'react-router-dom';
import { setUserSession, getToken } from '../utils/Common';

const Login = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  
  // Handle form auth
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post('/api/auth', { email, password }, {headers: {'Content-Type': 'application/json'}});
      if (response.status === 200) {
        setUserSession(response.data.token, response.data.user);
        navigate('/dashboard');
      } else {
        throw new Error('Login failed');
      }
    } catch (err) {
      alert(err);
    } finally {
      setLoading(false);
     
    }
  };

  useEffect(() => {
    const token = getToken(); // Call getUser to fetch user data from localStorage
    if (token) {
      navigate('/dashboard');
    } else {
      navigate('/'); // Optionally clear the user data if not found
    }
  }, []);

  return (
    <div className="flex h-screen bg-[#101827]">
      {/* Left Section - Login Form */}
      <div className="w-full md:w-1/2 bg-transparent flex flex-col justify-center px-5 md:px-20 ">
        <div className="flex items-center justify-center -mt-20">
          <img src={official_logo} alt="Official Logo Ashley" className="object-contain w-32 h-28"/>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="border border-[#F4DDBE] rounded-md p-8">
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-[#F4DDBE]">
              Email
            </label>
            <div className="mt-2 flex items-center border rounded-md">
              <FiMail className="text-gray-500 ml-2" />
              <input
                type="email"
                id="email"
                className="w-full py-2 px-3 text-sm bg-transparent text-[#F4DDBE] border-none rounded-md focus:outline-none"
                placeholder="email@company.com"
                value={email}
                required
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div className="mb-4">
            <label htmlFor="password" className="block text-sm font-medium text-[#F4DDBE]">
              Password
            </label>
            <div className="mt-2 flex items-center border rounded-md">
              <FiLock className="text-gray-500 ml-2" />
              <input
                type="password"
                id="password"
                className="w-full py-2 px-3 text-sm bg-transparent text-[#F4DDBE] border-none rounded-md focus:outline-none"
                placeholder="Password"
                value={password}
                required
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {/* Remember me checkbox */}
          <div className="flex items-center mb-6">
            <input
              type="checkbox"
              id="remember"
              className="w-4 h-4 text-blue-600 border-gray-300 rounded"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label htmlFor="remember" className="ml-2 text-sm text-[#F4DDBE]">
              Remember me
            </label>
          </div>

          <p className="text-sm text-[#F4DDBE] mb-6 mt-6">
            Don’t have an account?{" "}
            <a href="#" className="text-sky-200 hover:underline" onClick={() => navigate('/register')}>
                Sign up
            </a>
          </p>

          <button
            type="submit"
            className="w-full py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50"
          >
            Sign in to your account
          </button>
        </form>

        {/* Social Login Buttons */}
        <div className="flex items-center justify-center mt-4 space-x-4">
          <button className="flex items-center px-4 py-2 text-xs text-gray-800 bg-white border rounded-md shadow-md hover:bg-gray-100">
            <FaGoogle className="mr-1" />
            Sign in with Google
          </button>
          <button className="flex items-center px-4 py-2 text-xs text-white bg-black border rounded-md shadow-md hover:bg-gray-900">
            <FaApple className="mr-1" />
            Sign in with Apple
          </button>
        </div>

        {/* Forgot password link */}
        <div className="mt-4 text-center">
          <a href="#" className="text-sm text-slate-300 hover:underline">
            Forgot password?
          </a>
        </div>
      </div>

      {/* Right Section - Illustration */}
      <div className="md:block w-1/2 text-slate-700 items-center justify-center relative hidden">
        <div className="flex items-center justify-center w-full h-full">
          <img
            src={login_logo}
            alt="Main Illustration"
            className="object-contain w-3/5 h-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
